import FrontEndStore from './FrontEndStore';
import UpdateForApproval from './UpdateForApproval';

export default class UpdatesForApprovalStore extends FrontEndStore {
  constructor(updateForApprovalData) {
    super(updateForApprovalData);
    this.storeType = UpdatesForApprovalStore;
    this.loading = !updateForApprovalData || updateForApprovalData.loading;
    this.store = updateForApprovalData ?
      updateForApprovalData.store || updateForApprovalData.map(d => new UpdateForApproval(d)) :
      [];
  }

  isEmpty() {
    return this.store.length === 0;
  }

  isLoading() {
    return this.loading;
  }
}
